/**
 * Language options for selectors and i18n.
 * `value` is the app/i18n code. `iso6392` is the ISO 639-2 display code.
 */

export const languageOptions = [
	{ label: "language.no", value: "nb-NO", iso6392: "NOR" },
	{ label: "language.en", value: "en", iso6392: "ENG" },
] as const;
